import { Directive, Input, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
// import { CKEditorComponent } from '@ckeditor/ckeditor5-angular';
import { BehaviorSubject, Subscription } from 'rxjs';
import { startWith } from 'rxjs/operators';
import { CkeditorImagesService } from './ckeditor-images.service';

@Directive({
  selector: '[appCkeditorImageDelete]',
  standalone: false
})
export class CkeditorImageDeleteDirective implements OnInit, OnDestroy {

  @Input() formControl: UntypedFormControl;

  imageDeletionSubscription: Subscription;
  newImageSubscription: Subscription;

  imagenesAEliminar = [];

  imagenesNuevas = [];

  private resetSubject = new BehaviorSubject(true);

  // constructor(private host: CKEditorComponent, private ckeditorImagesService: CkeditorImagesService) {
  // }

  ngOnInit(): void {
    // this.imageDeletionSubscription = this.ckeditorImagesService.imageDeletionRegister(this.resetSubject.asObservable(),
    // this.formControl,
      // this.host.config.origen, this.host.config.store).subscribe({
      //   next: (res) => {
      //     this.imagenesAEliminar = res;
      //   }
      // });

    // this.newImageSubscription = this.ckeditorImagesService.newImageRegister(this.resetSubject.asObservable(),
    //   this.formControl).subscribe({
    //     next: (res) => {
    //       this.imagenesNuevas = res;
    //     }
    //   });
  }

  reset() {
    this.imagenesNuevas = [];
    this.resetSubject.next(true);
  }

  eliminarImagenesSinUsar() {
    // this.ckeditorImagesService.eliminarImagenes(this.imagenesAEliminar, this.host.config.origen, this.host.config.store);
  }

  eliminarImagenesNuevas() {
    // this.ckeditorImagesService.eliminarImagenes(this.imagenesNuevas, this.host.config.origen, this.host.config.store);
  }

  ngOnDestroy(): void {
    this.eliminarImagenesSinUsar();
    this.eliminarImagenesNuevas();
    if (this.imageDeletionSubscription) {
      this.imageDeletionSubscription.unsubscribe();
    }
    if (this.newImageSubscription) {
      this.newImageSubscription.unsubscribe();
    }
  }
}
